import type { UseMutationOptions } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import apiRoutes from '@/lib/apiRoutes';
import httpClient from '@/lib/httpClient';
import type { DefaultQueryError } from '../types';
import type { Contract, ContractRequestParams } from './types';

export const postCreateContractFn = async (body: ContractRequestParams) => {
  const response = await httpClient.post<Contract>(
    apiRoutes.contract.create,
    body
  );
  return response.data;
};

export const usePostCreateContractMutation = (
  opts?: UseMutationOptions<Contract, DefaultQueryError, ContractRequestParams>
) =>
  useMutation<Contract, DefaultQueryError, ContractRequestParams>(
    postCreateContractFn,
    opts
  );
